
import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { FallbackView } from '../../_metronic/partials';
import Dashboard from '../pages/Dashboard';
import PageList from '../pages/PageList';
import PageManagement from '../pages/PageManagement';
import RoleManagement from '../pages/RoleManagement';
import UserRolePermission from '../pages/UserRolePermission';
import Logout from "../pages/Logout";
import Users from "../pages/Users";

import MyProfile from '../pages/MyProfile';
import UserLog from '../pages/UserLog';
	
import PaymentList from '../pages/PaymentList';
import CustomerList from '../pages/CustomerList';
import ProductList from '../pages/ProductList';

// Order Management Pages
import OrderList from '../pages/OrderList';
import OrderDetails from '../pages/OrderDetails';
import OrderCreate from '../pages/OrderCreate';
import InvoiceList from '../pages/InvoiceList';
import InvoiceDetails from '../pages/InvoiceDetails';
import InvoiceCreate from '../pages/InvoiceCreate';

// Shipment Management Pages
import ShipmentList from '../pages/ShipmentList';
import ShipmentDetails from '../pages/ShipmentDetails';
import ShipmentCreate from '../pages/ShipmentCreate';

// Payment Receive Management Pages
import PaymentReceiveList from '../pages/PaymentReceiveList';
import PaymentReceiveDetails from '../pages/PaymentReceiveDetails';
import PaymentReceiveCreate from '../pages/PaymentReceiveCreate';

// Delivery Associate Management Pages
import DeliveryAssociateList from '../pages/DeliveryAssociateList';

// Purchase Order Management Pages
import PurchaseOrderList from '../pages/PurchaseOrderList';
import PurchaseOrderForm from '../pages/PurchaseOrderForm';
import PurchaseOrderDetail from '../pages/PurchaseOrderDetail';

export function PrivateRoutes() {

	return (
		<Suspense fallback={<FallbackView />}>
			<Switch>
				<Route path='/dashboard' component={Dashboard} />
			
				<Route path='/accesscontrol-users' component={Users} />
				<Route path='/accesscontrol-rolemanagement' component={RoleManagement} />
				<Route path='/accesscontrol-userrolepermission' component={UserRolePermission} />
				<Route path='/accesscontrol-page-list' component={PageList} />
				<Route path='/accesscontrol-pagemanagement' component={PageManagement} />
				
				<Route path="/logout" component={Logout} />
				<Route path="/my-profile" component={MyProfile} />
			=
				<Route path="/payment-list" component={PaymentList} />
				<Route path="/customer-list" component={CustomerList} />
				<Route path="/product-list" component={ProductList} />
				
				{/* Order Management Routes */}
				<Route path="/sales-orders" exact component={OrderList} />
				<Route path="/sales-orders/create" component={OrderCreate} />
				<Route path="/sales-orders/:orderId" component={OrderDetails} />
				<Route path="/sales-invoices" exact component={InvoiceList} />
				<Route path="/sales-invoices/create/:orderId?" component={InvoiceCreate} />
				<Route path="/sales-invoices/:invoiceId" component={InvoiceDetails} />
				
				{/* Shipment Management Routes */}
				<Route path="/shipments" exact component={ShipmentList} />
				<Route path="/shipments/create/:orderId" component={ShipmentCreate} />
				<Route path="/shipments/:shipmentId" component={ShipmentDetails} />
				
				{/* Payment Receive Management Routes */}
				<Route path="/payments/receive" exact component={PaymentReceiveList} />
				<Route path="/payments/receive/create/:orderId?" component={PaymentReceiveCreate} />
				<Route path="/payments/receive/:paymentId" component={PaymentReceiveDetails} />
				
				{/* Delivery Associate Management Routes */}
				<Route path="/delivery-associates" exact component={DeliveryAssociateList} />
				
				{/* Purchase Order Management Routes */}
				<Route path="/purchase-orders" exact component={PurchaseOrderList} />
				<Route path="/purchase-orders/create" component={PurchaseOrderForm} />
				<Route path="/purchase-orders/:id" exact component={PurchaseOrderDetail} />
				<Route path="/purchase-orders/:id/edit" component={PurchaseOrderForm} />
				
				<Redirect exact from='/' to='/dashboard' />
				<Redirect to='error/404' />
			</Switch>
		</Suspense>
	)
}
